import { IEvaluationTypeService } from "../../service/evaluation/EvaluationTypeService";
import { IEvaluationType } from "../../model/evaluation/EvaluationType";

export default class UpdateEvaluationTypeInteractor {
  private evaluationTypeService: IEvaluationTypeService;

  constructor(evaluationTypeService) {
    this.evaluationTypeService = evaluationTypeService;
  }

  async execute(evaluationType: IEvaluationType) {
    return this.evaluationTypeService.updateEvaluationType(evaluationType);
  }
}
